var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddFolder = function SvgAddFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48036414,0 L10.789,2.858 L13.5,2.858 L13.5,5.858 L9.35480069,5.85714286 L7.047,3 L3,3 L3,13.572 L17.143,13.572 L17.142,9.5 L20.142,9.5 L20.1428571,16.5714286 L0,16.5714286 L0,0 L8.48036414,0 Z M19.5022321,1.5 L19.5022321,3.55915179 L21.3549107,3.55915179 L21.3549107,5.34486607 L19.5022321,5.34486607 L19.5022321,7.41517857 L17.6495536,7.41517857 L17.6495536,5.34486607 L15.7857143,5.34486607 L15.7857143,3.55915179 L17.6495536,3.55915179 L17.6495536,1.5 L19.5022321,1.5 Z",
    id: "Combined-Shape",
    fill: "#9CA4B5",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-folder.8b2bfc9d.svg";
export { ForwardRef as ReactComponent };